<template>
    <transition name="layout-fade">
        <Loader v-if="loading" style="max-width: 100%"/>
        <v-layout wrap v-else>
            <Navigation/>
            <v-slide-y-transition mode="out-in">
                <router-view/>
            </v-slide-y-transition>
        </v-layout>
    </transition>
</template>

<script>
    import Order from '../../api/order'
    import Booking from '../../api/booking'
    import Navigation from './Navigation'
    import Loader from '../../components/Loader/Layout'

    export default {
        name: 'orderBookingLayout',
        components: {
            Navigation,
            Loader
        },
        data: () => ({
            loading: false
        }),
        created () {
            this.setHeaderTitle('Заказы и бронирование')

            this.loading = true

            Order
                .getBadges()
                .then(response => this.$store.commit('changeBadgesState', response.data.data))
                .catch(error => new Error(error))
                .finally(() => this.loading = false)

            Booking
                .getAll()
                .then(response => this.$store.commit('storeBookings', response.data.data))
                .catch(error => new Error(error))
        },
    }
</script>
